import React from 'react';

import {
  Option,
  Select,
  Pagination as ShellPagination,
} from '@sede-enterprise/shell-ds-react-framework';

interface PaginationProps {
  currentPage: number;
  pageSize: number;
  totalRecords: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  paginationOptions: number[];
}

const PaginationSection: React.FC<PaginationProps> = ({
  currentPage,
  pageSize,
  totalRecords,
  onPageChange,
  onPageSizeChange,
  paginationOptions,
}) => {
  return (
    <div className='pagination-container'>
      <div className='total-rows'>{`Total Rows: ${totalRecords}`}</div>
      <ShellPagination
        onChange={onPageChange}
        current={currentPage}
        pageSize={pageSize}
        total={totalRecords}
        position='right'
        data-testid='pagination'
        size='small'
      />
      <Select
        placeholder='Page Size'
        showSearch={false}
        onChange={onPageSizeChange}
        value={pageSize}
        className='select-page-size'
        data-testid='page-size'
        allowClear={false}
        size='small'
      >
        {paginationOptions.map((item) => (
          <Option key={`pagination_opt_${item}`} value={item}>
            {item}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default PaginationSection;
